var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666667 3.33333H10C10.3682 3.33333 10.6667 3.63181 10.6667 4V15.3333C10.6667 15.7015 10.3682 16 10 16H0.666667C0.298477 16 0 15.7015 0 15.3333L0 4C0 3.63181 0.298477 3.33333 0.666667 3.33333ZM1.33333 4.66667V14.6667H9.33333V4.66667H1.33333ZM15.3333 0C15.7015 0 16 0.298477 16 0.666667V12C16 12.3682 15.7015 12.6667 15.3333 12.6667H12V11.3333H14.6667V1.33333H6.66667V2H5.33333V0.666667C5.33333 0.298477 5.63181 0 6 0H15.3333Z",
    fill: "#516A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.f44fd28da1207721737699f2002f0ed8.svg";
export { ForwardRef as ReactComponent };